export default function PageHero({ eyebrow, title, lead }) {
  return (
    <section className="sas-section-sm border-b border-[color:var(--sas-line)]" data-testid="page-hero">
      <div className="sas-container">
        <div className="max-w-3xl">
          {eyebrow && (
            <div className="flex items-center gap-3 mb-5">
              <span className="sas-hero-mark" aria-hidden />
              <span className="sas-eyebrow">{eyebrow}</span>
            </div>
          )}
          <h1 className="sas-h1">{title}</h1>
          {lead && <p className="sas-lead mt-5">{lead}</p>}
        </div>
      </div>
    </section>
  );
}
